module.exports = __webpack_public_path__ + "img/mrxweb.92ab4866.svg";